import ScaffoldService from './scaffold-service';

function adjustVersionToSort(version) {
  if (!version) {
    return version;
  }

  const splitted = version.split('.');
  return splitted.map((item) => pad(item, 10)).join('.');

  function pad(num, size) {
    var s = num + '';
    while (s.length < size) s = '0' + s;
    return s;
  }
}

export default {
  namespaced: true,

  state: {
    loading: true,
    current: null,
  },

  getters: {
    current: (state) => state.current,
    loading: (state) => state.loading,
    versions: (state) => {
      if (!state.current) {
        return [];
      }

      const versions =
        state.current.availableVersions || [];

      versions.sort((a, b) => {
        return adjustVersionToSort(b).localeCompare(
          adjustVersionToSort(a),
        );
      });

      return versions;
    },

    hasManyVersions: (state, getters) =>
      getters.versions.length > 1,
  },

  mutations: {
    current(state, payload) {
      state.current = payload || null;
    },

    loading(state, payload) {
      state.loading = !!payload;
    },
  },

  actions: {
    async set({ commit }, payload) {
      commit('current', payload);
    },

    async load({ commit }, { id, version }) {
      commit('current', null);

      let scaffold;

      if (version) {
        scaffold = await ScaffoldService.findAtVersion(
          id,
          version,
        );
      } else {
        scaffold = await ScaffoldService.find(id);
      }

      commit('current', scaffold);

      if (!scaffold) {
        throw new Error();
      }
    },
  },
};
